export default __webpack_public_path__ + "static/the-churls-and-the-charitable-2dea5830cffdf226398459b4e552a94d.jpg";